<div class="modal-header" *ngIf="isModal">
  <h4 class="modal-title">{{ 'COMMON.PRINT_PREVIEW' | translate }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div id="modal-print-content" class="ec-root">
    <div class="ec-page">

      <div class="ec-header">
        <div class="ec-logo">
          <img *ngIf="logoTourOperator" [src]="getAbsoluteTourOperatorLogo()" alt="Logo Tour Operator"
            (error)="onLogoError($event)">
        </div>
        <div class="agency">
          <strong>{{ iter?.agency?.name }}</strong>
          <span class="contacts">
            <a *ngIf="iter?.agency?.telephone" class="contact-link" [href]="'tel:' + iter?.agency?.telephone">
              <i class="fas fa-phone"></i> {{ iter?.agency?.telephone }}
            </a>
            <ng-container *ngIf="iter?.agency?.email">
              <span *ngIf="iter?.agency?.telephone"> · </span>
              <a class="contact-link" [href]="'mailto:' + iter?.agency?.email">
                <i class="fas fa-envelope"></i> {{ iter?.agency?.email }}
              </a>
            </ng-container>
          </span>
        </div>
      </div>

      <h1 class="ec-title">{{ 'HOME.SUMMARY' | translate }}</h1>
      <p class="ec-sub">
        {{ 'COMMON.REFERENCE' | translate }} {{ iter?.riferimento }}
        <ng-container *ngIf="iter?.name"> · {{ iter?.name }}</ng-container>
        <ng-container *ngIf="totalPax"> · {{ totalPax }} {{ 'COMMON.PERSON_PLURAL' | translate }}</ng-container>
        <ng-container *ngIf="passengerNames"> · {{ passengerNames }}</ng-container>
        <ng-container *ngIf="iter?.duration"> · {{ iter?.duration }} {{ 'ITINERARY.NIGHTS' | translate }}</ng-container>
      </p>

      <h2 class="sec">{{ 'COMMON.PRINT_EC_SERVICES' | translate }}</h2>
      <table class="svc-table">
        <thead>
          <tr>
            <th class="col-type">{{ 'COMMON.PRINT_EC_TYPE' | translate }}</th>
            <th>{{ 'COMMON.PRINT_EC_SERVICE' | translate }}</th>
            <th class="col-date">{{ 'COMMON.PRINT_EC_DATE' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let service of services">
            <td><span class="tag">{{ service.tag }}</span></td>
            <td>
              <span class="t">{{ service.title }}</span>
              <span class="count" *ngIf="service.count">×{{ service.count }}</span>
              <div class="d" *ngIf="service.detail">{{ service.detail }}</div>
            </td>
            <td class="date">{{ service.date }}</td>
          </tr>
        </tbody>
      </table>

      <h2 class="sec">{{ 'SUMMARY.QUOTE-TITOLO' | translate }}</h2>
      <table class="quote-table">
        <tbody>
          <tr>
            <td>{{ 'SUMMARY.QUOTE-TERRA' | translate }}</td>
            <td class="r">{{ quote.landServices | localizedCurrency:"EUR":'symbol' }}</td>
          </tr>
          <tr>
            <td>{{ 'SUMMARY.QUOTE-VOLO' | translate }}</td>
            <td class="r">{{ quote.flightTickets | localizedCurrency:"EUR":'symbol' }}</td>
          </tr>
          <tr>
            <td>{{ 'SUMMARY.QUOTE-TAX' | translate }}</td>
            <td class="r">{{ quote.flightTaxes | localizedCurrency:"EUR":'symbol' }}</td>
          </tr>
          <tr *ngFor="let fee of feeList">
            <td>{{ fee.name }}</td>
            <td class="r">{{ fee.price | localizedCurrency:"EUR":'symbol' }}</td>
          </tr>
          <tr *ngFor="let insurance of insuranceList">
            <td>{{ insurance.name }}</td>
            <td class="r">{{ insurance.price | localizedCurrency:"EUR":'symbol' }}</td>
          </tr>
          <tr>
            <td>{{ 'SUMMARY.QUOTE-PREVENTIVO-ADV' | translate }}</td>
            <td class="r">{{ quote.preventivo | localizedCurrency:"EUR":'symbol' }}</td>
          </tr>
          <tr>
            <td>{{ (commissionType === 'net' ? 'SUMMARY.COMMISSION-TYPE-NET' : 'SUMMARY.COMMISSION-TYPE-COM') | translate }}</td>
            <td class="r">{{ quote.commission | localizedCurrency:"EUR":'symbol' }}</td>
          </tr>
          <tr *ngIf="quote.hasWithholdingTax">
            <td>{{ amountApis?.withholdingTaxLabel }}</td>
            <td class="r">{{ quote.withholding | localizedCurrency:"EUR":'symbol' }}</td>
          </tr>
          <tr>
            <td>{{ 'SUMMARY.OPTION-SERVICES' | translate }}</td>
            <td class="r">{{ quote.optionServices | localizedCurrency:"EUR":'symbol' }}</td>
          </tr>
          <tr class="total">
            <td>{{ 'SUMMARY.TOTAL-ADV' | translate }}</td>
            <td class="r">{{ quote.total | localizedCurrency:"EUR":'symbol' }}</td>
          </tr>
        </tbody>
      </table>

      <div class="ec-footer">
        <span>{{ 'COMMON.PRINT_EC_GENERATED' | translate }}</span>
        <span>{{ 'COMMON.REFERENCE' | translate }} {{ iter?.riferimento }}</span>
      </div>

    </div>
  </div>
</div>

<div class="modal-footer" *ngIf="isModal">
  <button type="button" class="btn btn-primary" (click)="print()">
    <i class="fas fa-print"></i> {{ 'COMMON.PRINT' | translate }}
  </button>
</div>
